// extracted by mini-css-extract-plugin
module.exports = {"cell":"EcgMetaHeader_cell__31G2g","dialablePhone":"EcgMetaHeader_dialablePhone__3xSkd"};